import { h, Component } from "preact";
import { Link } from "preact-router/match";
import CMSComponent from "../CMSComponent";
import { css } from "emotion";
import Button from "../global/Button";
import Image from "../Image";
import LogoServices from "../../services/LogoServices";
import ColorServices from "../../services/ColorServices";
import config from "../../config";

import { firstOfType } from "../../utils/CssUtils";

const dropdownIcon = require("../../assets/ic_dropdown_white.svg");
const charityIcon = require("../../assets/registered_charity_logo.png");
const footerLogo = LogoServices.getLogo("whiteTeal");
const helpDocsURL = config("HELP_DOCS_URL");

const wrapper = css({
  backgroundColor: ColorServices.getColor("footer"),
  paddingTop: 40
});

const links = css({
  borderBottom: "1px solid white",
  padding: "0px 60px 50px 60px",
  display: "flex",
  color: ColorServices.getColor("white"),
  position: "relative",
  img: {
    width: 140,
    height: 24,
    marginRight: 80
  },
  div: {
    marginRight: 80,
    h2: {
      fontSize: 14,
      marginBottom: 16
    }
  },
  ul: {
    listStyleType: "none",
    margin: 0,
    padding: 0
  },
  li: {
    marginBottom: 8
  },
  a: {
    color: ColorServices.getColor("white"),
    fontSize: 14,
    fontWeight: 600
  },
  "@media(max-width: 768px)": {
    padding: "0px 14px 24px 14px",
    div: {
      marginRight: 0,
      display: "block",
      margin: "0 auto",
      marginBottom: 24,
      textAlign: "center"
    },
    "#findEvents": {
      display: "none"
    },
    img: {
      width: 140,
      height: 24,
      display: "block",
      margin: "0 auto",
      marginBottom: 24,

      [firstOfType()]: {
        display: "none"
      }
    }
  },
  "@media(max-width: 600px)": {
    padding: "0px 14px 24px 14px",
    display: "block",
    margin: "0 auto",
    div: {
      marginRight: 0,
      display: "block",
      margin: "0 auto",
      marginBottom: 24,
      textAlign: "center"
    },
    img: {
      width: 140,
      height: 24,
      display: "block",
      margin: "0 auto",
      marginBottom: 24
    }
  }
});

const charityIconStyles = css({
  width: "80px !important",
  height: "80px !important",
  marginRight: "60px !important",
  position: "absolute",
  right: 0,
  bottom: 32,
  "@media(max-width: 768px)": {
    marginRight: "auto !important",
    marginTop: 16,
    bottom: "auto",
    top: "auto",
    left: "auto",
    right: "auto",
    position: "relative"
  }
});

const socialMedia = css({
  padding: "16px 60px",
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "row-reverse",
  a: {
    marginLeft: 10
  },
  "@media(max-width: 600px)": {
    padding: "16px 14px",
    display: "flex",
    flexDirection: "row-reverse",
    flexWrap: "wrap",
    justifyContent: "space-evenly",
    a: {
      marginLeft: 12,
      marginRight: 12
    }
  }
});

const addressBar = css({
  position: "absolute",
  bottom: 0,
  "@media(max-width: 768px)": {
    position: "relative",
    bottom: "auto",
    textAlign: "center"
  }
});

const drowDown = css({
  fontSize: 18,
  borderRadius: 4,
  backgroundColor: ColorServices.getColor("footer"),
  borderColor: "transparent",
  backgroundImage: `url(${dropdownIcon})`,
  backgroundRepeat: "no-repeat",
  backgroundPositionX: "100%",
  backgroundPositionY: "50%",
  padding: "5px 12px",
  verticalAlign: "super",
  paddingRight: 24,
  color: "#fff",
  margin: "0 16px",
  option: {
    "&:last-of-type": {
      borderBottomLeftRadius: 4,
      borderBottomRightRadius: 4
    }
  }
});

class Footer extends Component {
  constructor(props) {
    super(props);
  }

  changeLocaleFunction = e => {
    const { changeLocale } = this.props;
    changeLocale(e.target.value);
  };

  render() {
    const { locale, localeData, contentData } = this.props;
    const { consoleURL } = localeData;
    const socialMediaLinks =
      contentData && contentData.data && contentData.data.socialMedia
        ? contentData.data.socialMedia
        : [];

    const companyList = [
      ["About us", `/${locale}/about-us`],
      ["Our Story", `/${locale}/our-stories`],
      ["Contact us", `/${locale}/contact-us`],
      [
        "Privacy Policy",
        `${consoleURL}/public/pdfs/humanitix_privacy_policy.pdf`
      ],
      [
        "Terms of Use",
        `${consoleURL}/public/pdfs/humanitix_promoter_agreement-${locale}.pdf`
      ]
    ];
    const servicesList = [
      ["Search Events", `/${locale}/search`],
      ["Features & Pricing", `/${locale}/features-and-pricing`],
      [`Our Impact`, `/${locale}/our-impact`],
      [`Sign In`, `${consoleURL}/signin`]
    ];

    const locationsList =
      locale === "nz"
        ? [
            ["Auckland events", `/${locale}/events/new-zealand/auckland`],
            ["Wellington events", `/${locale}/events/new-zealand/wellington`],
            ["Tauranga events", `/${locale}/events/new-zealand/tauranga`],
            ["Events this weekend", `/${locale}/events/weekend`]
          ]
        : [
            ["Sydney events", `/${locale}/events/australia/sydney`],
            ["Brisbane events", `/${locale}/events/australia/brisbane`],
            ["Melbourne events", `/${locale}/events/australia/melbourne`],
            ["Canberra events", `/${locale}/events/australia/canberra`],
            ["Perth events", `/${locale}/events/australia/perth`],
            ["Adelaide events", `/${locale}/events/australia/adelaide`],
            ["Events this weekend", `/${locale}/events/weekend`]
          ];
    return (
      <div class={wrapper}>
        <div class={links}>
          <img src={footerLogo} alt="Humanitix Logo" />

          <div>
            <h2>COMPANY</h2>
            <ul>
              {companyList.map(company => {
                return (
                  <li>
                    <a href={company[1]}>{company[0]}</a>
                  </li>
                );
              })}
            </ul>
          </div>
          <div>
            <h2>SERVICES</h2>
            <ul>
              {servicesList.map(services => {
                return (
                  <li>
                    <a href={services[1]}>{services[0]}</a>
                  </li>
                );
              })}
              <li>
                <a href={helpDocsURL} target="_blank">
                  Help
                </a>
              </li>
            </ul>
          </div>
          <div id="findEvents">
            <h2>FIND EVENTS</h2>
            <ul>
              {locationsList.map(services => {
                return (
                  <li>
                    <a href={services[1]}>{services[0]}</a>
                  </li>
                );
              })}
            </ul>
          </div>
          {locale === "au" ? (
            <Image
              imageURL={charityIcon}
              styleSheet={charityIconStyles}
              alt="Australian Approved Charity"
            />
          ) : null}
          <p style={{ fontSize: 12 }} className={addressBar}>
            {locale === "nz"
              ? `© Humanitix New Zealand Charitable Trust ${new Date().getFullYear()}, PwC Tower Level 22/188 Quay St Auckland CBD New Zealand`
              : `© Humanitix Limited ${new Date().getFullYear()}, 3 Minna Cl Belrose NSW Australia 2085`}
          </p>
        </div>
        <div className={socialMedia}>
          <div>
            {socialMediaLinks.links
              ? socialMediaLinks.links.map((link, index) => {
                  return (
                    <a
                      href={link}
                      aria-label={socialMediaLinks.ariaLabels[index]}
                    >
                      <Image
                        imageURL={socialMediaLinks.icons[index].fields.file.url}
                        alt={socialMediaLinks.icons[index].fields.description}
                      />
                    </a>
                  );
                })
              : null}
          </div>
          <select
            onChange={this.changeLocaleFunction}
            className={drowDown}
            label="Select your locale"
            aria-label="Select your locale"
          >
            <option
              value="au"
              selected={locale === "au"}
              label="Australia"
              aria-label="Australia"
            >
              Australia
            </option>
            <option
              value="nz"
              selected={locale === "nz"}
              label="New Zealand"
              aria-label="New Zealand"
            >
              New Zealand
            </option>
          </select>
        </div>
      </div>
    );
  }
}

export default CMSComponent("footer", Footer, 470);
